import { api } from './api'

export const Cart = {
    async add(product_id, quantity, product) {
        const qty = document.getElementById('quantity')

        if (qty) {
            quantity = qty.value
        }
        const response = await api.post(
            'checkout/cart/add',
            `product_id=${product_id}&quantity=${quantity}`
        )

        await this.updateMiniCartInfo()
        this.notify('cart-info', response)
        gtag("event", "add_to_cart", {
            currency: "RON",
            value: product.price * quantity,
            items: [
                {
                    item_id: product.sku,
                    item_name: product.name,
                    item_brand: product.manufacturer_name,
                    price: product.price,
                    quantity: quantity
                }
            ]
        });
    },
    async update(key, quantity) {
        const response = await api.post(
            'checkout/cart/edit',
            `key=${key}&quantity=${quantity}`
        )
        this.notify('cart-info', response)
    },
    async remove(key, open = true, product) {
        const response = await api.post(
            'checkout/cart/remove',
            `key=${key}`
        ).then()

        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo()

        if (response.cartItems === 0) {
            location.href = '/index.php?route=checkout/cart';
        }
        if (open) {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('open-cart'))
            }, 100)
        }
        gtag("event", "remove_from_cart", {
            currency: "RON",
            value: product.total.substr(0,product.total.length - 4),
            items: [
                {
                    item_id:product.sku,
                    item_name: product.name,
                    item_brand: product.manufacturer_id,
                    price: product.price.substr(0,product.price.length - 4),
                    quantity: product.quantity
                }
            ]
        });
    },
    async coupon(c) {
        const response = await api.post(
            'extension/total/coupon/coupon',
            `coupon=${c}`
        )
        if (response.error) {
            window.dispatchEvent(new CustomEvent('modal', {
                detail: {
                    message: `<p class="tw-text-red-500 tw-text-base">${response.error}</p>`,
                    title: '',
                    size: 'sm:tw-max-w-md'
                }
            }));
            return;
        }

        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo()

        window.dispatchEvent(new CustomEvent('modal', {
            detail: {
                message: `<p class="tw-text-green-500 tw-text-base">${response.message}</p>`,
                title: '',
                size: 'sm:tw-max-w-md'
            }
        }));
    },
    async shipping(c) {
        const response = await api.post(
            'quickcheckout/shipping_method/updateshipping',
            `code=${c}`
        )
        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo(false)
    },
    notify(eventName, response) {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: {
                message: response.success,
                image: response.image,
                cartItems: typeof response.cartItems !== 'undefined' ? response.cartItems : false
            }
        }))
    },
    async updateMiniCartInfo() {
        const cartInfo = (await api.get('common/cart/info')).text()
        cartInfo.then((data) => {
            document.getElementById('cart').innerHTML = data
        })
    },
    async updateCheckoutCartInfo(refresh = true) {
        const checkoutCart = (await api.get('quickcheckout/cart')).text()
        checkoutCart.then((data) => {
            document.getElementById('cart_view').innerHTML = data
        })
        if (refresh) {
            window.location.reload();
        }
    }
}